let initialized = false;

export function initIntercom() {
  if (initialized || window.themeTrackingSuppressed) return;
  initialized = true;

  let loading;
  let booted = false;
  let showRequested = false;
  const settings = { ...window.intercomSettings, custom_launcher_selector: '' };
  window.intercomSettings = settings;

  const load = () => {
    if (loading) return loading;
    if (typeof window.Intercom !== 'function') {
      const queue = (...args) => queue.q.push(args);
      queue.q = [];
      window.Intercom = queue;
    }
    if (!booted) {
      window.Intercom(window.Intercom.q ? 'boot' : 'update', settings);
      booted = true;
    }
    if (!window.Intercom.q) return Promise.resolve();

    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://widget.intercom.io/widget/${settings.app_id}`;
      script.onload = resolve;
      script.onerror = () => {
        script.remove();
        reject(new Error('Chat could not be loaded. Please try again.'));
      };
      document.head.appendChild(script);
    }).catch(error => {
      loading = undefined;
      throw error;
    });
    return loading;
  };

  const activate = event => {
    if (!event.target.closest?.('.open-intercom') || window.themeTrackingSuppressed) return;
    if (event.type === 'click') {
      event.preventDefault();
      showRequested = true;
    }
    void load().then(() => {
      if (!showRequested) return;
      showRequested = false;
      window.Intercom('show');
    }).catch(error => console.warn(error.message));
  };

  document.addEventListener('pointerover', activate);
  document.addEventListener('focusin', activate);
  document.addEventListener('click', activate);
}
